import React from "react";

const CohortKPICards = ({ summary }) => {
	const cards = [
		{
			label: "Total Users",
			value: summary?.total_users?.toLocaleString(),
			subtext: "in cohort",
			icon: "👥",
			color: "#3B82F6"
		},
		{
			label: "D0 Activation",
			value: `${summary?.activation?.d0_rate}%`,
			subtext: `${summary?.activation?.d0_earners?.toLocaleString()} users earned`,
			icon: "🎯",
			color: summary?.activation?.d0_rate > 50 ? "#10B981" : "#F59E0B"
		},
		{
			label: "D7 Retention",
			value: `${summary?.activation?.d7_rate}%`,
			subtext: `${summary?.activation?.d7_earners?.toLocaleString()} active users`,
			icon: "📈",
			color: summary?.activation?.d7_rate > 10 ? "#10B981" : summary?.activation?.d7_rate > 5 ? "#F59E0B" : "#EF4444"
		},
		{
			label: "D15 Retention",
			value: `${summary?.activation?.d15_rate}%`,
			subtext: `${summary?.activation?.d15_earners?.toLocaleString()} active users`,
			icon: "🏆",
			color: summary?.activation?.d15_rate > 5 ? "#10B981" : summary?.activation?.d15_rate > 2 ? "#F59E0B" : "#EF4444"
		},
		{
			label: "Median Withdrawal Day",
			value: summary?.withdrawals?.median_withdrawal_day !== null 
				? `D${summary?.withdrawals?.median_withdrawal_day}`
				: "N/A",
			subtext: `${summary?.withdrawals?.d15_users} total withdrawals`,
			icon: "⏱️",
			color: "#8B5CF6"
		},
		{
			label: "D15 Revenue",
			value: `$${(summary?.revenue?.d15_cumulative / 1000).toFixed(1)}K`,
			subtext: `$${(summary?.revenue?.d7_cumulative / 1000).toFixed(1)}K at D7`,
			icon: "💰",
			color: "#06B6D4"
		},
		{
			label: "D15 Payout",
			value: `$${(summary?.payout?.d15_cumulative / 1000).toFixed(1)}K`,
			subtext: `$${(summary?.payout?.d7_cumulative / 1000).toFixed(1)}K at D7`,
			icon: "💸",
			color: "#EC4899"
		},
		{
			label: "D15 Withdrawals",
			value: `$${(summary?.withdrawals?.d15_coins / 1000).toFixed(2)}`,
			subtext: `${summary?.withdrawals?.d15_users ?? 0} users · $${(summary?.withdrawals?.d7_coins / 1000).toFixed(2)} at D7`,
			icon: "🏦",
			color: "#14B8A6"
		}
	];

	return (
		<div style={{
			display: "grid",
			gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
			gap: "var(--spacing-lg)"
		}}>
			{cards.map((card, idx) => (
				<div key={idx} style={{
					padding: "20px",
					borderLeft: `4px solid ${card.color}`,
					backgroundColor: "white",
					borderRadius: "8px",
					boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
				}}>
					<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
						<p style={{ margin: 0, fontSize: "13px", fontWeight: "600", color: "var(--text-muted)", textTransform: "uppercase" }}>
							{card.label}
						</p>
						<span style={{ fontSize: "24px" }}>{card.icon}</span>
					</div>
					<p style={{ margin: "0 0 4px 0", fontSize: "28px", fontWeight: "700", color: card.color }}>
						{card.value}
					</p>
					<p style={{ margin: 0, fontSize: "12px", color: "var(--text-muted)" }}>
						{card.subtext}
					</p>
				</div>
			))}
		</div>
	);
};

export default CohortKPICards;